import { Grid } from '@mui/material';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PurchaseReceiveDetailsTable from './PurchaseReceiveDetailsTable';
import StatusBadge from '../../generals/StatusBadge';

const PurchaseReceiveContent = React.forwardRef((props, ref) => {
  const { purchaseData, viewBillDetails, customTabChange } = props;
  const { pathname } = useLocation();

  var url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const navigate = useNavigate();

  const viewPurchaseOrder = id => {
    const customerRoute = `/${currModuleId}/${currModuleName}/${'purchase-order'}/details/${id}`;
    window.open(customerRoute, '_blank');
  };

  return (
    <section ref={ref} className="print-content mt-2 w-full max-w-6xl text-filterTextColor">
      <Grid className="border-2 ml-1" container spacing={2}>
        <Grid className="border-2 mx-2 my-2" item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <div>
                <div>
                  <span className="#476ef8 font-bold">PURCHASE RECEIVED</span>
                  <br></br>
                  <span className="">
                    <i className="subheading font-bold">
                      <span
                        onClick={() => viewPurchaseOrder(purchaseData?.purchase_receive_ref_no)}
                        className="text-primary subheading font-bold"
                      >
                        Receive # {purchaseData?.purchase_receive_number}{' '}
                      </span>{' '}
                    </i>
                  </span>{' '}
                  <br></br>
                  <span className="">
                    <i className="subheading font-bold">
                      <span
                        className="text-black cursor subheading font-bold text-primary"
                        onClick={() => viewPurchaseOrder(purchaseData?.purchase_receive_ref_no)}
                      >
                        Purchase Order Number:{purchaseData?.purchase_receive_ref_no}{' '}
                      </span>{' '}
                    </i>
                  </span>{' '}
                  <br></br>
                </div>
              </div>
            </Grid>
            <Grid item className="pl-1 flex justify-end" xs={6}>
              <div>
                <StatusBadge
                  statusId={purchaseData?.purchase_receive_status_id}
                  statusName={purchaseData?.purchase_receive_status_name}
                  size="md"
                />
              </div>
            </Grid>

            <Grid item xs={12}>
              <Grid className="pb-2" container spacing={0}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={1}>
                      <div>
                        <span className="heading text-filterTextColor font-bold">Date:</span>
                      </div>
                    </Grid>
                    <Grid item className="" xs={6}>
                      <div className="heading ml-4 text-filterTextColor">{purchaseData?.purchase_receive_date_string}</div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid className="border-2 mx-2 my-2" item xs={12}>
          <section>
            <PurchaseReceiveDetailsTable tableData={purchaseData?.purchase_receive_details} />
          </section>
        </Grid>
      </Grid>
    </section>
  );
});

export default PurchaseReceiveContent;
